import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../../../css/EngagementTable.less';

import { SatCoreRegister } from '../../../SatCoreRegistry';

import { register } from '../../../i18n';

import EngagementService from '../../../services/EngagementService';

const EngagementHeaderMainFeedbackUsageCells = observer((props = {}) => {
  const { engagementManager } = useContext(MobXProviderContext);

  const activeTable = engagementManager.activeEngagementTable;

  const { handleHeaderClick } = props;

  const t = register('EngagementTable');

  const renderEngagementHeaderMainFeedbackUsageCells = () => {
    const isOnlyShowingMainCells = activeTable === 'summary';
    return (
      <>
        {isOnlyShowingMainCells && renderEngagementHeaderMainFeedbackUsageCell({
          allowPopupComponent: true,
          className: `main-cell engagement-header-label feedbackUsage active-table-${activeTable}`,
          isHeaderCell: true,
          popupContent: t('feedbackUsageDescriptionMain'),
          popupOn: 'hover',
          popupTrigger: (
            <div className='clickable'
              data-value='feedbackUsage'
              onClick={handleHeaderClick}>
              {t('feedbackUsage')}
            </div>
          )
        })}
        {!isOnlyShowingMainCells && renderEngagementHeaderMainFeedbackUsageCell({
          allowPopupComponent: true,
          cellText: t('feedbackUsage'),
          className: `main-cell engagement-header-label feedbackUsage active-table-${activeTable}`,
          isHeaderCell: true,
          popupContent: t('feedbackUsageDescription'),
          popupOn: 'click'
        })}
      </>
    );
  };

  const renderEngagementHeaderMainFeedbackUsageCell = (props = {}) => {
    return EngagementService.renderEngagementCell(props);
  };

  return renderEngagementHeaderMainFeedbackUsageCells();
});
export default EngagementHeaderMainFeedbackUsageCells;

SatCoreRegister('EngagementHeaderMainFeedbackUsageCells', EngagementHeaderMainFeedbackUsageCells);
